module.exports = __webpack_public_path__ + "img/process.b46ed4b6.png";